import { Flex } from 'antd';
import { KnowledgeBase as KnowledgeBaseModule } from '@modules/knowledge-base';
import styles from './knowledge-base.module.scss';

export const KnowledgeBase = () => (
  <Flex className={styles.root} align="center" justify="center">
    <KnowledgeBaseModule />
  </Flex>
);
